import { Activity } from 'react';
import { Tab, TabList, TabPanel, Tabs } from '~/commonComponents';
import { useGetCandidateResume } from '~/domain/PermanentJobs';
import { IJob, IUser } from '~/models';
import { TNullable } from '~/types/Nullable';
import { ExperienceSkillsPreview, ResumePreview } from '../../components';

interface IExperienceOverview {
  job?: TNullable<IJob>;
  postingId?: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
}

export const ExperienceOverview = ({
  job,
  postingId,
  professional,
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
}: IExperienceOverview) => {
  const resolvedPostingId = postingId ?? job?.postingId;

  const { data: resume } = useGetCandidateResume(
    { professionalId: professional?.id || '', postingId: resolvedPostingId },
    { enabled: !!resolvedPostingId && !!professional?.id },
  );

  const hasGoTuResume = !!resume;

  return (
    <>
      <Activity mode={hasGoTuResume ? 'visible' : 'hidden'}>
        <Tabs initialTab={0} style={{ alignItems: 'flex-start' }} tabListStyle={{ gap: 16 }}>
          <TabList>
            <Tab
              title="GoTu Resume"
              textStyle={{
                fontSize: 20,
              }}
            />
            <Tab
              title="Experience & Skills"
              textStyle={{
                fontSize: 20,
              }}
            />
          </TabList>
          <TabPanel>
            <ResumePreview
              educations={(resume?.education || [])?.map((it) => ({
                graduatesAt: it.graduationDate,
                institutionName: it.institutionName,
              }))}
              experiences={(resume?.experiences || [])?.map((it) => ({
                employerName: it.employerName,
                endsAt: it.endDate,
                isCurrentEmployer: it.isCurrentEmployer,
                startsAt: it.startDate,
                title: it.title,
              }))}
              professionalName={resume?.professionalFirstName || ''}
              summaries={resume?.summary || ''}
            />
            <ExperienceSkillsPreview
              job={job}
              professional={professional}
              hasWorkedWithDSO={hasWorkedWithDSO}
              hasWorkedWithOffice={hasWorkedWithOffice}
            />
          </TabPanel>
        </Tabs>
      </Activity>
      <Activity mode={hasGoTuResume ? 'hidden' : 'visible'}>
        <ExperienceSkillsPreview
          job={job}
          professional={professional}
          hasWorkedWithDSO={hasWorkedWithDSO}
          hasWorkedWithOffice={hasWorkedWithOffice}
        />
      </Activity>
    </>
  );
};
